<template>
  <div class="onboarding-content">
    <slot />
  </div>
</template>

<script>
export default {
  name: "OnboardingContent"
};
</script>

<style scoped>
.onboarding-content {
  @apply flex flex-1 flex-col p-4;

  @screen sm {
    @apply p-6;
  }

  @screen md {
    @apply p-10;
  }
}
</style>
